import { data } from '../../svg/Exclamation/data';
import { makeIcon } from '../makeIcon';

export const Exclamation = makeIcon(data, 'exclamation', 'Exclamation');

export default Exclamation;
